import { DraftEmail } from "@zickko/shared";

type Props = {
  email: DraftEmail;
  onSelectEmail: () => void;
};

export const DraftsEmailListItemWidget = (props: Props) => {
  const { email, onSelectEmail } = props;
  const subject = email.subject || "No Subject";

  const handleEmailClick = () => {
    onSelectEmail();
  };

  return (
    <div className="email-list-item-widget-container" onClick={handleEmailClick}>
      <div className="email-list-item-widget">
        <div className="heading">
          <div className="time">9 months ago</div>
        </div>
        <div className="subject">{subject}</div>
        <div className="tags">
          <div className="meeting-tag">meeting</div>
          <div className="work-tag">work</div>
          <div className="important-tag">important</div>
        </div>
      </div>
    </div>
  );
};
